const request = (url, recaptcha, body) =>
  fetch(`${window.INTERNAL_HOSTNAME}/_internal/account/${url}`, {
    credentials: 'include',
    method: body ? 'POST' : 'GET',
    headers: {
      'Content-Type': 'application/json',
      ...(recaptcha
        ? {
            'X-Recaptcha-Code': recaptcha,
          }
        : {}),
    },
    body: body && JSON.stringify(body),
  }).then(resp => resp.json());

export const passwordRecoveryRequest = (email, recaptcha) =>
  request('password-recovery-email', recaptcha, { email });

export const setNewPasswordRequest = (hash, username, password, recaptcha) =>
  request('new-password', recaptcha, {
    hash,
    username,
    password,
  });

export const createUserRequest = (input, recaptcha) =>
  request('signup', recaptcha, input);

export const validateInput = input => request('validate', undefined, input);

export const loginWithCredentials = credentials =>
  request('login', undefined, credentials);

export const fetchMe = () => request('me');

export const logout = () => request('logout');

export const logoutFromClassic = url => fetch(url);
